export default __webpack_public_path__ + "static/media/shape3.ec28cec6.svg";